<button
  class="button {{ variant() }} {{ color() }} {{ `size-${size()}` }}  {{
    size() === 24 ? 'f-body-s f-medium' : 'f-body-m f-medium'
  }}"
  [class.spinner]="spinner()"
  [type]="actionType()"
  [disabled]="disabled()"
>
  <div class="content">
    @if (leftIcon(); as leftIcon) {
      <onyx-icon [name]="leftIcon" [size]="iconSize()"></onyx-icon>
    } @else {
      <div class="left">
        <ng-content select="[left]"></ng-content>
      </div>
    }

    <ng-content></ng-content>

    @if (rightIcon(); as rightIcon) {
      <onyx-icon [name]="rightIcon" [size]="iconSize()"></onyx-icon>
    } @else {
      <div class="right">
        <ng-content select="[right]"></ng-content>
      </div>
    }
  </div>

  @if (spinner()) {
    <onyx-spinner
      [color]="spinnerColor()"
      [size]="spinnerSize()"
    ></onyx-spinner>
  }
</button>
